import React from "react";
import { motion } from "framer-motion";
import { Lock, Sparkles, LayoutGrid, Eye } from "lucide-react";

const ITEMS = [
  {
    icon: Lock,
    title: "Lease Vault",
    tag: "Storage",
    text: "Secure infrastructure agreement storage.",
  },
  {
    icon: Sparkles,
    title: "Infrastructure Intelligence",
    tag: "Insights",
    text: "Benchmarking and market visibility.",
  },
  {
    icon: LayoutGrid,
    title: "Infrastructure Marketplace",
    tag: "Access",
    text: "Curated infrastructure opportunities.",
  },
  {
    icon: Eye,
    title: "Infrastructure Visibility",
    tag: "Transparency",
    text: "Operational transparency for owners and municipalities.",
  },
];

export default function WhatWeDo() {
  return (
    <section
      id="what-we-do"
      className="relative border-y border-[#1E293B] bg-[#0B1422]/40"
    >
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-14 max-w-2xl"
        >
          <p className="mb-3 font-display text-[12px] font-extrabold uppercase tracking-[0.18em] text-[#38BDF8]">
            What InfraYield Does
          </p>
          <h2 className="font-display text-3xl font-bold leading-[1.05] tracking-[-0.04em] text-[#F8FAFC] sm:text-5xl">
            The operating system for
            <br className="hidden sm:block" /> infrastructure ownership.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#1E293B] bg-[#1E293B] sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((it, i) => (
            <motion.article
              key={it.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: i * 0.07 }}
              className="group flex h-full flex-col bg-[#0F1B2D] p-8 transition-colors hover:bg-[#10202F]"
              data-testid={`product-card-${i}`}
            >
              <div className="mb-7 flex items-center justify-between">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#1E293B] bg-[#07111F] text-[#22C55E]">
                  <it.icon className="h-5 w-5" />
                </div>
                <span className="rounded-full border border-[#1E293B] px-2.5 py-0.5 font-body text-[10px] uppercase tracking-[0.14em] text-[#38BDF8]">
                  {it.tag}
                </span>
              </div>
              <h3 className="font-display text-[22px] font-semibold leading-[1.15] text-[#F8FAFC]">
                {it.title}
              </h3>
              <p className="mt-3 font-body text-[15px] leading-relaxed text-[#94A3B8]">
                {it.text}
              </p>
              <div className="mt-auto pt-8">
                <span className="font-display text-xs font-medium text-[#334155]">
                  0{i + 1} / 04
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
